import { createFingerprint } from './utils';

let cookieDomain = '.7usslot.com';

if (!location.hostname.includes('7usslot.com')) {
  cookieDomain = location.hostname;
}

let hasFixexpire = false;

export function getCookie(key) {
  const cookie = document.cookie;
  const cookieArr = cookie.split(';');
  const cookieObj = {};
  cookieArr.forEach(item => {
    const [k, v] = item.split('=');
    const trimmedKey = k ? k.trim() : '';
    const trimmedValue = v ? v.trim() : '';
    if (trimmedKey && trimmedValue) cookieObj[trimmedKey] = trimmedValue;
  });

  if (!hasFixexpire) {
    if (cookieObj['us_h5_md5_key']) {
      setCookie('us_h5_md5_key', cookieObj['us_h5_md5_key']);
    }
    if (cookieObj['us_h5_sourceurl_key']) {
      setCookie('us_h5_sourceurl_key', cookieObj['us_h5_sourceurl_key']);
    }
    hasFixexpire = true;
  }

  return key ? cookieObj[key] : cookieObj;
}

export function setCookie(key, value, expires = 365 * 24 * 60 * 60 * 1000) {
  const date = new Date();
  date.setTime(date.getTime() + expires);
  document.cookie = `${key}=${value};domain=${cookieDomain};path=/;expires=${date.toUTCString()}`;
}

export const initSourceurl = async () => {
  const uuid = (await createFingerprint()) as string;
  const sourceurl = getCookie('us_h5_sourceurl_key');

  if (!sourceurl) {
    setCookie('us_h5_sourceurl_key', uuid);
    return;
  }
  const sourceurlList = sourceurl.split(',');
  if (!sourceurlList.includes(uuid)) {
    // 首部添加
    sourceurlList.unshift(uuid);

    if (sourceurlList.length > 5) {
      // 尾部删除
      sourceurlList.pop();
    }
    setCookie('us_h5_sourceurl_key', sourceurlList.join(','));
  }
};
